import type { ReactNode } from "react";
import { View, YStack } from "tamagui";
import { shadow } from "../../../themes/token-shadow";
type FannedCardsProps = {
  children: ReactNode;
};

// Two fanned document cards (muted card behind, white card in front) drawn in the
// 160×160 design space shared by the claim-check and bill graphics. Only the
// foreground card's content differs between the two types, so it comes in as children.
export const FannedCards = ({
  children
}: FannedCardsProps) => <View width={160} height={160} position="relative" data-sentry-element="View" data-sentry-component="FannedCards" data-sentry-source-file="FannedCards.tsx">
    <View position="absolute" top={14} left={42} width={108} height={140} borderRadius="$br3" borderWidth="$border1" borderColor="$borderDefault" backgroundColor="$surface0" rotate="6deg" data-sentry-element="View" data-sentry-source-file="FannedCards.tsx" />
    <YStack position="absolute" top={6} left={14} width={120} height={148} borderRadius="$br3" borderWidth="$border1" borderColor="$borderDefault" backgroundColor="$surface2" rotate="-8deg" paddingHorizontal="$sp1.5" paddingVertical="$sp2.5" gap="$sp1" alignItems="center" {...shadow.heavy} data-sentry-element="YStack" data-sentry-source-file="FannedCards.tsx">
      {children}
    </YStack>
  </View>;